import * as types from '../actions/actionTypes';
import initialState from './initialState';
import {sortBy, some, unionBy} from 'lodash';

export default function unmappedSuburbsReducer(state = initialState.unmappedSuburbs, action) {
  switch (action.type) {
    case types.LOAD_SUBURBS_UNMAPPED_SUCCESS:
      return {...action.unmappedSuburbs};
    case types.SAVE_SUBURBS_TOREGION_SUCCESS:
      return {...state, items: [...state.items.filter(x => x.id != action.suburb.id)]};
    case types.REMOVE_SUBURB_FROMREGION_SUCCESS:
      let suburbs = [...state.items];
      if(!_.some(suburbs, x => x.id == action.suburb.id)){
        suburbs.push(action.suburb);
      }
      return {...state, items: _.sortBy(suburbs, x => x.name.toLowerCase())};
    case types.DELETE_REGION_SUCCESS:
      return {...state, items: _.sortBy(_.unionBy([...state.items], action.region.suburbs, x => x.id), x => x.name.toLowerCase())};
    default:
      return state;
  }
}
